module.exports = __webpack_public_path__ + "static/grafika-new-cb38488bc459714b7aa564d16076566f.png";